import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import { PrimaryButton } from '../../../../../components/Button/ActionButtons';

import {
  RunBarRow,
  SelectionCount,
  Hint,
  Progress,
} from './styles';
import texts from './texts.json';

const MigrationRunBar = ({
  selectedCount,
  hasTargetCoach,
  isSameCoach,
  isRunning,
  progress,
  onRun,
}) => {
  const canRun = selectedCount > 0 && hasTargetCoach && !isSameCoach && !isRunning;

  /*
    The same-coach case is deliberately silent — CoachPairSelector already warns about it,
    and repeating it here would put two warnings on screen for one mistake.
  */
  const hint = (!hasTargetCoach && texts.needsTarget)
    || (selectedCount === 0 && !isSameCoach && texts.needsSelection)
    || '';

  return (
    <RunBarRow>
      <SelectionCount>{format(texts.selected, { count: selectedCount })}</SelectionCount>
      {isRunning
        ? <Progress aria-live="polite">{format(texts.progress, progress)}</Progress>
        : (
          <>
            {!!hint && <Hint>{hint}</Hint>}
            <PrimaryButton
              variant="light"
              $fitToContent
              disabled={!canRun}
              onClick={onRun}
            >
              {texts.migrate}
            </PrimaryButton>
          </>
        )}
    </RunBarRow>
  );
};

MigrationRunBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  hasTargetCoach: PropTypes.bool.isRequired,
  isSameCoach: PropTypes.bool.isRequired,
  isRunning: PropTypes.bool.isRequired,
  progress: PropTypes.shape({
    migrated: PropTypes.number,
    total: PropTypes.number,
  }),
  onRun: PropTypes.func.isRequired,
};

MigrationRunBar.defaultProps = {
  progress: null,
};

export default MigrationRunBar;
